"use strict";

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {findIn} from "../libs/@elements/dom-utils";
import {getConfigValue} from '../libs/@elements/config-utils';
import Pristine from "../libs/pristine/pristine.js";
import {defaultOptions} from "./form-validation";
import {getLoadingContainer} from "./loading-spinner";

const defaultSelectors = {
    base: '.js-form-validation__delivery'
};

let pristineForms = [];

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createFormValidation(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createFormValidation(form, options = defaultOptions) {

    if (getConfigValue('lang')) {
        Pristine.setLocale(getConfigValue('lang'))
    }

    const pristine = new Pristine(form, options);

    let addressForm = findIn('.js-form-validation__delivery__address', form);
    let alternativeCheckbox = findIn('.js-form-validation__delivery__alternative-input', form);
    let addressState = findIn('#customer_shippingAddressState', form);
    let addressType = findIn('#customer_shippingAddressType', form);

    let alternativeBase = findIn('.js-form-validation__delivery__alternative-base', form);
    let alternativePostal = findIn('.js-form-validation__delivery__alternative-postal', form);
    let alternativeStation = findIn('.js-form-validation__delivery__alternative-station', form);

    let existingAddress = findIn('.js-form-validation__delivery__alternative-existing', form);

    let addressFormInputs = addressForm.querySelectorAll('input:not([type="hidden"]), select');
    let alternativeBaseInputs = alternativeBase.querySelectorAll('input:not([type="hidden"]), select');
    let alternativePostalInputs = alternativePostal.querySelectorAll('input:not([type="hidden"]), select');
    let alternativeStationInputs = alternativeStation ? alternativeStation.querySelectorAll('input:not([type="hidden"]), select') : null;
    let existingAddressInputs = existingAddress ? existingAddress.querySelectorAll('input:not([type="hidden"]), select') : null;


    form.addEventListener('submit', function (e) {
        const submitButtonEl = document.getElementsByClassName('js-submit-customer-form__btn');
        if(alternativeCheckbox.checked) {
            if(addressState.value === 'address-existing') {
                if ((pristine.validate(existingAddressInputs)) && (pristine.validate(addressFormInputs))){
                    addLoadingIndicator(submitButtonEl)
                } else {
                    e.preventDefault();
                }
            }
            if(addressState.value === 'address-new') {
                if(addressType.value === 'postal') {
                    if ((pristine.validate(alternativeBaseInputs)) && (pristine.validate(alternativePostalInputs)) && (pristine.validate(addressFormInputs))){
                        addLoadingIndicator(submitButtonEl)
                    } else {
                        e.preventDefault();
                        console.log('adresse and postal invalid');
                    }
                }
                if(addressType.value === 'packingStation') {
                    if ((pristine.validate(alternativeBaseInputs)) && (pristine.validate(alternativeStationInputs)) && (pristine.validate(addressFormInputs))){
                        addLoadingIndicator(submitButtonEl)
                    } else {
                        e.preventDefault();
                        console.log('adresse and packingStation invalid');
                    }
                }
            }
        } else {
            if (!pristine.validate(addressForm.querySelectorAll('input:not([type="hidden"]), select'))){
                e.preventDefault();
            } else {
                addLoadingIndicator(submitButtonEl)
            }
        }
    });

    pristineForms.push(pristine);
    return pristine
}
export function updatePristine(form) {
    let pristine = pristineForms.filter((object) => {
        return object.form === form;
    });

    pristine[0].reset(); // resets errors
    pristine[0].destroy(); // clean up

    createFormValidation(form)
}

function addLoadingIndicator(el) {
    for (let i = 0; i < el.length; i++) {
        const button = el[i];
        if (button.style.position !== 'absolute' || 'relative') {
            button.style.position = 'relative';
        }
        button.setAttribute('disabled', true);
        button.innerHTML += getLoadingContainer();

        //setTimeout(() => {
        //    button.removeAttribute('disabled');
        //    const loadingContainer = button.getElementsByClassName('loading-overlay')
        //    button.removeChild(loadingContainer[0])
        //}, 5000)
    }
}
